import React from "react";
import swal from "../../helpers/swal";
import { axiosget } from "../../helpers/httprequest";
import { useQueryClient } from "@tanstack/react-query";
import { Button } from "../../components/ui/Button";
import { FiCheckCircle } from "react-icons/fi";

const VerifyPayment = ({ v }) => {
  const [loading, setLoading] = React.useState(false);
  const queryClient = useQueryClient();

  const _verify = async () => {
    try {
      setLoading(true);

      // Check if this is a gateway payment (has gateway info in trxdata)
      const gatewayName = v?.trxdata?.gateway;
      const isGatewayPayment = gatewayName && gatewayName !== "remita";

      let req;
      if (isGatewayPayment) {
        // Use appropriate endpoint based on gateway
        if (gatewayName === "clane") {
          // Use the new Clane verification endpoint that handles legacy payCode records
          req = await axiosget(`ms_payments/verify-clane-appfee/${v.trxcode}`);
        } else {
          // Use general gateway verification endpoint
          req = await axiosget(`ms_payments/verify-trxcode/${v.trxcode}`);
        }
        swal(req?.data?.type || "info", req?.data?.message);
      } else {
        // Use original Remita verification (ms_application_fee endpoint)
        req = await axiosget(`ms_application_fee/${v.trxcode}`);
        swal(req?.data?.type, req?.data?.message);
      }

      // Refresh the payment list
      queryClient.invalidateQueries({ queryKey: ["generatedRRR"] });
      queryClient.invalidateQueries({ queryKey: ["dashboardDataset"] });

      setLoading(false);
    } catch ({ message }) {
      swal("error", message);
      setLoading(false);
    }
  };

  return (
    <Button
      variant="primary"
      size="sm"
      onClick={_verify}
      loading={loading}
      disabled={loading || v.verified}
      leftIcon={!loading && <FiCheckCircle />}
    >
      {loading ? "Verifying..." : "Verify Payment"}
    </Button>
  );
};

export default VerifyPayment;
